export default __webpack_public_path__ + "8ed3dd778ea3d197cff8b0e676af0bfc.png";